import Vue from 'vue'
import './pollyfills'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import router from './router'
import store from "./store/"
// import FirebaseAuthPlugin from './plugins/FirebaseAuthPlugin'
import Viewer from 'v-viewer'
import { sync } from 'vuex-router-sync'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import { JWTDecode } from '@/utils/common'
import Papaparse from 'papaparse'

Vue.config.productionTip = false;

sync(store, router)

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from '@/plugins/SidebarPlugin'

// Axios
import axios from 'axios'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import 'viewerjs/dist/viewer.css'

import sidebarLinks from './sidebarLinks'

var baseURL = process.env.VUE_APP_ROOT_API || 'http://127.0.0.1:5005'
// axios setup
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

  // TODO: Refactor
  const user = JWTDecode(token)
  if (user.role === 'user') {
    baseURL = baseURL + '/api/w'
  } else if (user.role === 'customer') {
    baseURL = baseURL + '/api/c'
  }
}

axios.defaults.baseURL = baseURL
Vue.prototype.$http = axios;
Vue.prototype.$papaparse = Papaparse

// plugin setup
// Vue.use(FirebaseAuthPlugin)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify, {horizontalAlign: 'right', verticalAlign: 'bottom'})
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields'
})
Vue.use(Viewer)
Vue.use(SweetModal)
locale.use(lang)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// // Axios Global Error Handle
// axios.interceptors.response.use(null, function (err) {
//   if (err.response.status === 401) {
//     console.log('401')
//     try {

//       router.beforeEach((to, from, next) => {
//         console.log('beforeEach')
//         if (to.matched.some(x => x.meta.requiresAuth)) {
//           const authUser = localStorage.getItem('token')
//           if (!authUser) {
//             next({ path: '/login' })
//           } else {
//             next()
//           }
//         } else {
//           next()
//         }
//       })
//     } catch (err) {
//       console.log()
//       console.log(err)
//     }
//   } else {
//     return Promise.reject(err)
//   }
// })
